import type { FormState } from "./types";

export type QuotePayloadData = Omit<FormState, "attachments"> & {
  attachments: { active: boolean };
};

export interface QuoteSubmitPayload {
  department: string;
  contact: { name: string; company: string; email: string; phone: string };
  data: QuotePayloadData;
  subject: string;
  emailText: string;
}

export class QuoteDataMapper {
  toPayload(form: FormState): QuotePayloadData {
    return {
      ...form,
      attachments: { active: form.attachments.active },
    };
  }

  activeFiles(form: FormState): File[] {
    return form.attachments.active ? form.attachments.files : [];
  }
}
